export const PARTNER_SYNCHRONIZATION_INCOMPLETE_STATUS = "INCOMPLETE";
